// src/services/knowledge-api.ts
// 自社紹介文＆専門用語取得用のAPI通信サービス

import { KNOWLEDGE_GET_LIST_API } from '../config';
import { fetchWithTokenRefresh } from './token-manager';
import { logApiError } from '../utils/errorLogger';

/** 全APIリクエスト共通ヘッダー */
const JSON_HEADERS = {
  'Content-Type': 'application/json',
  'Cache-Control': 'no-cache, no-store',
  'Pragma': 'no-cache',
} as const;

/** getKnowledgeList レスポンス */
export interface KnowledgeListResponse {
  companyintroduction: string;
  knowledgelist: string[];
}

export const knowledgeAPI = {
  /**
   * 自社紹介文と専門用語リストを取得する
   * 取得失敗時は空の値を返す（呼び出し元のフローを止めない）
   */
  async getKnowledgeList(): Promise<KnowledgeListResponse> {
    try {
      const response = await fetchWithTokenRefresh(KNOWLEDGE_GET_LIST_API, {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`APIエラー: ${response.status} ${response.statusText} ${errorText}`);
      }

      const data = await response.json();
      if (data.statuscode !== 200) {
        throw new Error(data.message || '自社紹介文・専門用語取得に失敗しました');
      }

      return {
        companyintroduction: data.companyintroduction || '',
        knowledgelist: Array.isArray(data.knowledgelist) ? data.knowledgelist : [],
      };
    } catch (error) {
      logApiError('knowledgeAPI.getKnowledgeList', error, KNOWLEDGE_GET_LIST_API, 'POST');
      return { companyintroduction: '', knowledgelist: [] };
    }
  },
};
